import ApiService from "../../../common/api.service";
import { router } from "../../../router";
import { Notification } from "element-ui";
export async function resetPassword({ commit }, data) {
  try {
    ApiService.init("heroku");
    commit("RESET_PASSWORD_REQUEST");
    const _response = await ApiService.post("/v1/auth/oauth/reset-password", data);
    commit("RESET_PASSWORD_SUCCESS", { results: _response });
    Notification.success({
      title: "Success",
      dangerouslyUseHTMLString: true,
      message: "Anda berhasil mereset password"
    });
    router.push("/reset-password/success");
  } catch (error) {
    commit("RESET_PASSWORD_ERROR", { result: error.message });
    let messageError = "";
    if (error.response.data.status == 401) {
      messageError = error.response.data.errors.message;
    } else if (error.response.data.status == 400) {
        messageError += `<li>${error.response.data.errors.stackTrace.error.message}</li>`;
    }
    else {
      error.response.data.errors.stackTrace.map(item => {
        messageError += `<li>${item.msg}</li>`;
      });
    }
    Notification.error({
      title: "Error",
      dangerouslyUseHTMLString: true,
      message: `<ul>${messageError}</ul>`
    });
  }
}
